export const processRegionsData = (regions: any[], metric: any) => {
  return regions.map((region: any) => {
    let tempObjR: any = {
      ...region,
      subRows: [],
      metric_name: region?.region,
      group_sk: metric?.group?.group_sk,
      group_name: metric?.group?.group_name,
      metric_id: metric?.metric_id,
      goal_type: metric?.goal_type,
      metric_precision: metric?.metric_precision,
      level: 1,
    }

    region?.storeData?.forEach((column: any) => {
      tempObjR[`${column?.column_id}`] = column?.column_value
      tempObjR[`${column?.column_id}_color`] = column?.column_color
      tempObjR[`${column?.column_id}_datatype`] = column?.column_datatype
    })

    return tempObjR
  })
}

export const processPracticesData = (practices: any[], metric: any) => {
  return practices.map((practice: any) => {
    let tempObjP: any = {
      ...practice,
      metric_name: practice.name,
      metric_original_name: metric?.metric_name,
      group_sk: metric?.group_sk,
      group_name: metric?.group_name,
      metric_id: metric?.metric_id,
      metric_precision: metric?.metric_precision,
      level: 2,
    }

    console.log("practices", practices)
    console.log("tempObjP", tempObjP)

    practice?.storeData?.forEach((column: any) => {
      tempObjP[`${column?.column_id}`] = column?.column_value
      tempObjP[`${column?.column_id}_color`] = column?.column_color
      tempObjP[`${column?.column_id}_datatype`] = column?.column_datatype
    })

    return tempObjP
  })
}

export const findRowById = (data: any[], id: string): any => {
  for (const row of data) {
    if (row.id === id) {
      return row
    }
    if (row.subRows) {
      const found = findRowById(row.subRows, id)
      if (found) {
        return found
      }
    }
  }
  return null
}
